import { createAction, props } from '@ngrx/store';

export const getAllHardware = createAction('[Hardware] Get All Hardware');
export const getAllHardwareSuccess = createAction(
  '[Hardware] Get All Hardware Success',
  props<{ data: any }>(),
);
export const searchHardware = createAction(
  '[Hardware] Search Hardware',
  props<{ search: string; assigned?: boolean; vehicleId?: number }>(),
);

export const searchHardwaresSuccess = createAction(
  '[Hardware] Search Hardware Success',
  props<{ data: any }>(),
);

export const searchHardwaresFailure = createAction(
  '[Hardware] Search Hardware Failure',
  props<{ error: any }>(),
);
